import React from 'react';
import 'react-chat-elements/dist/main.css';
import {Button, ChatList, Input} from "react-chat-elements";
import SmartDialog from "../../components/SmartDialog";
import TTLProxy from "../../common/TTLAsyncProxy";
import {TractorRequestEndpoints} from "../../common/ProxyEndpoints";
import Utils from "../../common/Utils";
import {ic_feedback as MessageIcon} from 'react-icons-kit/md/ic_feedback';
import Icon from 'react-icons-kit';
import {UncontrolledAlert} from 'reactstrap';
import MDProgress from 'react-md-progress-bar';
import moment from 'moment';
import {TextField} from "../../components/AuditExplorer/Elements";
import AppVariables from '../../common/AppVariables';
import {ChannelSubscription} from "../../common/UserNotifications/Subscriptions";
import NotificationChannels from "../../common/NotificationChannels";
import NotificationEvents from "../../common/NotificationEvents";

const INTERNAL_MESSAGE_USER = `${AppVariables.AppCompanyName} (SYSTEM)`;

class MessageView extends React.Component {

    constructor(props) {
        super(props);
        this.state = MessageView.getInitialState({});
    }

    static getInitialState({ message = "" , user = null }){

        return {
            message,
            user
        };
    }

    show(message,user){

        this.setState(MessageView.getInitialState({ message , user }), () => {
            this._dlg.show();
        });
    }

    render(){

        const { message , user } = this.state;

        return <SmartDialog ref={r => this._dlg = r}
                            title="Info">

            {user && <React.Fragment>
                <b>Sent By</b>
                <p>{user ? Utils.getUserName(user) : INTERNAL_MESSAGE_USER}</p>
                <hr/>
            </React.Fragment>}

            <b>Message</b>
            <TextField text={message} maxHeight={160}/>

        </SmartDialog>
    }

}

class RequestMessaging extends React.Component {

    constructor(props){
        super(props);
        this.state = RequestMessaging.getInitialState();
        this.proxy = TTLProxy.getInstance();
        this.pushMessage = this.pushMessage.bind(this);
    }

    static getInitialState(state){

        return {
            isBusy: false,
            request: state ? state.request: null,
            messages: [],
            inputMessage: "",
            errorMessage: null
        };

    }

    async loadState(){

        const { request } = this.state;

        this.setState({
            isBusy: true,
            errorMessage: null
        });

        try {

            const res = await this.proxy.processRequest(TractorRequestEndpoints.getRequestMessages(request.id));

            this.setState({
                messages: res.getPayload()
            });

        }
        catch (e) {

            this.setState({
                errorMessage: Utils.getResponseError(e)
            });

        }finally {

            this.setState({
                isBusy: false
            });

        }
    }

    show(request){

        this.setState(RequestMessaging.getInitialState({ request }), async () => {

            this._dlg.show();

            //
            await this.loadState();
        });

    }

    /**
     * Push message to list
     * @return {Promise<void>}
     */
    async pushMessage(message){

        const { messages } = this.state;

        //  append message
        messages.push(message);

        //  update messages
        this.setState({
            messages
        });

        //  scroll to last item
        this._messagesContainer.scrollBy(0,this._messagesContainer.scrollHeight);

    }

    async addMessage(){

        const { request , messages , inputMessage : message } = this.state;

        this.setState({
            isBusy: true,
            errorMessage: null
        });

        try{

            const res = await this.proxy.processRequest(TractorRequestEndpoints.createRequestMessage(request.id,{
                text: message,
                // markup: NOT_USED
            }));

            if(res.ok){

                const payload = res.getPayload();
                const messageInfo = await this.proxy.processRequest(TractorRequestEndpoints.getRequestMessage(request.id,payload.id));

                //  clear input
                this._input.clear();

                //  append message
                messages.push(messageInfo.getPayload());

                //  update messages
                this.setState({
                    messages
                });

                //  scroll to last item
                this._messagesContainer.scrollBy(0,this._messagesContainer.scrollHeight);

            }

        }
        catch (e) {

            this.setState({
                errorMessage: Utils.getResponseError(e)
            });

        }
        finally {

            this.setState({
                isBusy: false
            });


        }

    }

    render(){

        const { messages , errorMessage , isBusy } = this.state;

        return <SmartDialog title={<div>
            <span><Icon icon={MessageIcon} size={26}/> Request Messages</span><br/>
            <span className="font-lg ml-3" style={{ color: "#9e9e9e" }}>Request: #{this.state.request ? this.state.request.order_id : null}</span>
        </div> } large ref={r => this._dlg = r}>

            <MessageView ref={r => this._msgView = r}/>

            <ChannelSubscription channel={NotificationChannels.TractorRequestMessages}
                                 event={NotificationEvents.generic.create}
                                 onParsed={this.pushMessage}/>

            {errorMessage && <UncontrolledAlert color={"danger"}><i className="fa fa-exclamation-triangle"/>{errorMessage}</UncontrolledAlert>}

            <div style={{ minHeight: 320, maxHeight: 325 , overflowY: "auto"}} ref={r => this._messagesContainer = r}>

                {messages.length === 0 ? <div className="text-center p-5">
                    <span><i className="fa fa-smile-o fa-3x"/></span>
                    <p className="mt-1">Sorry, there are no messages posted yet!</p>
                    </div> : <ChatList className="chat-list"
                                       onClick={value => this._msgView.show(value.subtitle,value.instance.user)}
                                       dataSource={messages.map(msg => ({
                                            avatar: msg.user ? (Utils.getProfileImage(msg.user.admin.media) || '/img/avatars/user.png') : '/img/avatars/bot_icon.png',
                                            alt: msg.user ? msg.user.name : INTERNAL_MESSAGE_USER,
                                            title: msg.user ? Utils.getUserName(msg.user) : INTERNAL_MESSAGE_USER,
                                            subtitle: msg.text,
                                            date: moment(msg.date_created).toDate(),
                                            unread: 0,
                                            instance: msg
                                      }))}/>}
            </div>


            {isBusy && <MDProgress show/>}

            <hr/>

            <Input className="form-control form-input-select"
                   multiline
                   onChange={evt => {

                       this.setState({
                           inputMessage: evt.target.value
                       });

                   }}
                   placeholder="Enter message here"
                   autoHeight={false}
                   autoFocus
                   disabled={isBusy}
                   ref={r => this._input = r}
                   rightButtons={<Button color="white"
                                         backgroundColor="green"
                                         onClick={this.addMessage.bind(this)} text="Submit"/>}/>

        </SmartDialog>

    }

}

export default RequestMessaging;


// WEBPACK FOOTER //
// ./src/views/Request/RequestMessaging.js